import { fetch } from "../plugin/fetch";
export default {
    namespaced: true,
    state: {
        gameList: [],
        leftMenu:[]
    },
    mutations: {
        setList(state, payload) {
            state.gameList = payload.list;
        },
        setCommon(state, payload) {
            state.leftMenu = payload.left_menu;
        },
    },
    actions: {
        fetchCommon({ commit }) { 
            return new Promise(() => {
                fetch('/web/live/common').then(res => {
                    if (res.code==200) {
                        commit('setCommon', res.data);
                    }
                });
            });
        },
        fetchList({ commit }) {
            return new Promise(() => {
                fetch('/web/live', {}).then(res => {
                    if (res.code == 200) {
                        commit('setList', res.data);
                    }
                });
            });
        }
    },
}